module.exports = __webpack_public_path__ + "static/img/bg-line.84eabb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-line.png
// module id = vJ9U
// module chunks = 0